import React from "react";
import withStyles from "react-jss";
import classNames from "classnames";

const styles = theme => ({
    root: {
        position: "relative",
        "& > span": {
            fontSize: "12px",
            fontFamily: theme.fonts.medium,
            lineHeight: 0.71,
            letterSpacing: "2px",
            color: "#000000",
            position: "relative",
        },
    },
    isSortable: {
        "& > span:after": {
            position: "relative",
            content: "''",
            right: "-3px",
            top: "10px",
            width: 0,
            height: 0,
            borderLeft: "4px solid transparent",
            borderRight: "4px solid transparent",
            borderTop: `7px solid ${theme.palette.colors.disabled}`,
        },
    },
    [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
        root: {
            "& span": {
                fontSize: "10px",
            },
        },
        isSortable: {
            "& > span:after": {
                right: "-2px",
                top: "9px",
            },
        },
    },
});

const TableLabel = ({ children, classes, sortable }) => (
    <div
        className={classNames(classes.root, {
            [classes.isSortable]: !!sortable,
        })}
    >
        <span>{children}</span>
    </div>
);

export default withStyles(styles)(TableLabel);
